<div class="thomas-body">
  <dx-chat class="thomas-chat" [dataSource]="thomas.dataSource" [reloadOnChange]="false" [user]="currentUser"
    [showAvatar]="false" [showUserName]="false" [showDayHeaders]="false" [showMessageTimestamp]="false"
    messageTemplate="message" emptyViewTemplate="emptyView" (onMessageEntered)="onMessageEntered($event)">
    <div *dxTemplate="let data of 'message'">
      @if (data.message.author?.id === currentUser.id) {
        <div class="thomas-user-message">
          <button type="button" class="thomas-save-prompt" title="Save as a prompt" aria-label="Save this message as a prompt"
            (click)="managePrompts(data.message.text, thomas.replyIdFor(data.message))">
            <i class="material-icons">bookmark_add</i>
          </button>
          <div class="thomas-user">{{ data.message.text }}</div>
        </div>
      } @else {
        <js-thomas-reply [message]="data.message"></js-thomas-reply>
      }
    </div>
    <div *dxTemplate="let data of 'emptyView'" class="thomas-empty">
      <div class="thomas-start">
        <div class="thomas-welcome">Hi, I'm <span>Thomas</span>. Need any help?</div>
        <section class="thomas-saved" aria-label="Saved prompts">
          <div class="thomas-saved-header">
            @if (companyPrompts.length) {
              <div class="thomas-saved-switch" role="group" aria-label="Show prompts">
                <button type="button" [class.selected]="!showCompanyPrompts" [attr.aria-pressed]="!showCompanyPrompts" (click)="showPromptSet(false)">Personal</button>
                <button type="button" [class.selected]="showCompanyPrompts" [attr.aria-pressed]="showCompanyPrompts" (click)="showPromptSet(true)">Company</button>
              </div>
            }
            <span class="thomas-saved-spacer"></span>
            @if (myPrompts.length || companyPrompts.length) {
              <button type="button" class="thomas-link-button" (click)="managePrompts('')">
                <i class="material-icons" aria-hidden="true">add</i>
                <span>Add</span>
              </button>
            }
            <!-- always shown: prompts saved for other apps are only listed there -->
            <button type="button" class="thomas-link-button" (click)="managePrompts()">Manage</button>
          </div>
          @if (prompts.length) {
            <div class="thomas-saved-grid">
              @for (prompt of prompts; track prompt.id) {
                <button type="button" class="thomas-suggestion" [title]="prompt.text" (click)="thomas.send(prompt.text); focusComposer()">
                  <span>{{ prompt.description }}</span>
                </button>
              }
            </div>
          } @else {
            <button type="button" class="thomas-suggestion thomas-suggestion-add" (click)="managePrompts('')">
              <i class="material-icons" aria-hidden="true">add</i>
              <span>Add a prompt you use often</span>
            </button>
          }
        </section>
      </div>
    </div>
  </dx-chat>

  @if (thomas.queuedCount) {
    <div class="thomas-queue" role="status">{{ thomas.queuedCount }} {{ thomas.queuedCount === 1 ? 'message' : 'messages' }} queued</div>
  }
  <div class="thomas-footer">AI can make mistakes. Always review responses for accuracy.</div>

  @if (thomas.managingPrompts) {
    <js-thomas-prompts [draft]="promptDraft" [draftResponseId]="promptResponseId" (send)="sendPrompt($event)" (changed)="loadPrompts()" (closed)="closePrompts()"></js-thomas-prompts>
  }
</div>
